import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

export const useRequestCount = (userId) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!userId) {
            setCount(0);
            return;
        }

        const q = query(
            collection(db, 'friendRequests'),
            where('toUid', '==', userId),
            where('status', '==', 'pending')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setCount(snapshot.size);
        }, (error) => {
            console.error("Error listening to request count:", error);
        });

        return () => unsubscribe();
    }, [userId]);

    return count;
};
